<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="white"
  >
    <g id="Group_1059" data-name="Group 1059" transform="translate(-23 -105)">
      <rect
        id="Rectangle_17415"
        data-name="Rectangle 17415"
        width="16"
        height="16"
        transform="translate(23 105)"
        fill="none"
      />
      <g
        id="_039-storage"
        data-name="039-storage"
        transform="translate(-135 -17.789)"
      >
        <path
          id="Path_505"
          data-name="Path 505"
          d="M23.5,24H21.167a.5.5,0,0,1-.5-.5v-.833H11.334V23.5a.5.5,0,0,1-.5.5H8.5a.5.5,0,0,1-.5-.5V20.667a.5.5,0,0,1,.5-.5h15a.5.5,0,0,1,.5.5V23.5A.5.5,0,0,1,23.5,24Z"
          transform="translate(150 114.789)"
        />
        <g
          id="Group_1058"
          data-name="Group 1058"
          transform="translate(159.333 122.789)"
        >
          <path
            id="Path_506"
            data-name="Path 506"
            d="M15.623,13.71a1.1,1.1,0,0,1,1.1-1.105h.609V8.5a.5.5,0,0,0-.5-.5H14.667v2.833a.5.5,0,0,1-.5.5H12.5a.5.5,0,0,1-.5-.5V8H9.833a.5.5,0,0,0-.5.5V18.729a.5.5,0,0,0,.5.5h5.881a1.109,1.109,0,0,1-.091-.439Z"
            transform="translate(-9.333 -8)"
          />
          <path
            id="Path_507"
            data-name="Path 507"
            d="M22.232,13.271H20.348v1.423a.44.44,0,0,1-.435.439h-.87a.44.44,0,0,1-.435-.439V13.271H16.724a.44.44,0,0,0-.435.439v5.08a.44.44,0,0,0,.435.439h5.507a.44.44,0,0,0,.435-.439V13.71a.439.439,0,0,0-.434-.439Z"
            transform="translate(-9.333 -8)"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "icon-group",
};
</script>

<style scoped></style>
